module.exports = __webpack_public_path__ + "img/curved9.1ca8fb9c.jpg";